// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"351":"b4a3a54d","565":"c370634e"}[chunkId] + ".chunk.css");